import * as THREE from 'three';
import { matUtils } from '../../base';
import { View3dGlobal, ThreeView, ModelInfo } from '..';
import * as marietta3d from '../../../../marietta3d';
import { ObjectLoader } from './ObjectLoader';
import { OBBManager } from '../OBBManager';

export class FurnitureLoader {

    constructor() {}

    /* loadFurnitures
    * 家具アイテムの読込.
    */
    public loadAsync(): Promise<void> {
        const modelList = this.modelInfoList();
        if (!modelList.length) {
            return Promise.resolve();
        }

        const plan: marietta3d.AutoGen.AutoBase = ThreeView.get().planmgr.autoData;

        return Promise.all(modelList.map((modelinfo: ModelInfo) => {
            return new ObjectLoader().loadASync(modelinfo, plan.alternative(modelinfo.code))
                                        .then((object: THREE.Group) => {
                                            ThreeView.get().wcItemmgr.furnitureObjects.push(<THREE.Group>(object));
                                            // ThreeView.get().wcItemmgr.houseData.push(<THREE.Object3D>(object));
                                            this.setHouseData(object);
                                            ThreeView.get().wcItemmgr.registFloorObject(<THREE.Object3D>(object));
                                            matUtils.turnOffLights(<THREE.Group>object);
                                            ThreeView.get().scene.add(<THREE.Group>object);
                                            // object.userData.obb = new OBBManager(object);
                                        }).catch((message) => {
                                            console.warn(message);
                                        });
        })).then(() => {
            return Promise.resolve();
        });
    }

    /* modelInfoList
    * 読み込むアイテムのリストを作成.
    */
    private modelInfoList(): ModelInfo[] {
        return [...View3dGlobal.shared.equData,
                ...View3dGlobal.shared.furData,
                ...View3dGlobal.shared.extData,
                ...View3dGlobal.shared.ligData
                ].filter((item) => item.isValid()).map((item) => item.setupURL3D());
    }

    /* setHouseData
    * 選択可能アイテムをセットする
    */
    private setHouseData(obj: THREE.Object3D) {
        if (obj.userData.modelInfo.code == 'lig01_01' || obj.userData.modelInfo.code == 'lig07_02' || obj.userData.modelInfo.code == 'lig06_01') return;
        ThreeView.get().wcItemmgr.houseData.push(<THREE.Object3D>(obj));
    }
}
